/* 孫策（字伯符） */
import { gd } from '../../core/kit.ts';
import { defineHero, hook } from '../define.ts';

export default defineHero({
  id: 'sunce', name: '孫策', sub: '字伯符', faction: 'wu', role: '戰士', weapon: 'spear',
  look: { eye: 'fierce', fx: '#ffb24a', c: { metal: '#d9b45c' } },
  skills: [
    ['霸王突', 'charge', '突進撞擊造成 {90/140/190/240} 傷害；把敵人撞到城寨旁時額外暈眩 1 秒。', { x: { dmg: [90, 140, 190, 240] }, sig: 'bully' }],
    ['江東猛虎', 'spikes', '槍擊地面，地裂向前推進，造成 {80/130/180/230} 傷害。'],
    ['激昂', 'passive', '每擊殺或助攻一名武將，永久攻擊 +{2/3/4/5}，最多 20 層。', { pv: {}, sig: 'rouse', atk: [2, 3, 4, 5], max: 20, stack: 'rouseN' }],
    ['小霸王', 'slam', '躍起重擊，範圍 {290/440/590} 傷害並擊飛。'],
  ],
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 霸王突：撞到城寨旁額外暈眩
    hook('damage.after', 20, function (c, lost) {
      const act0 = c.act, t = c.t, own0 = c.own;
      if (act0 && lost > 0 && own0.team !== t.team && act0.sk.sig === 'bully' && t.alive && !(act0.bully || (act0.bully = {}))[t.id] && this.units.some((b) => b.structure && b.alive && gd(b.x, b.y, t.x, t.y) < b.r + 110)) { act0.bully[t.id] = 1; this.applyCC(own0, t, { stun: 1 }); }
    }),
    // 激昂：每次擊殺／助攻永久加攻擊
    hook('recalc', 10, function (u, sg) { if (sg && sg.rouse && u.rouseN) u.atk += u.rouseN * sg.rouse.v('atk'); }),
    // 激昂：擊殺或助攻（10 秒內打過）敵將時疊一層
    hook('kill.after', 10, function (src, t, was) {
      if (!was || t.alive) return;
      for (const h of this.heroes(1 - t.team)) {
        const r = h.sg && h.sg.rouse;
        if (!r || (h !== src && !(t.dmgBy[h.id] > this.t - 10)) || (h.rouseN || 0) >= r.sk.max) continue;
        h.rouseN = (h.rouseN || 0) + 1; this.recalc(h);
        if (h.human) this.tell(h, `激昂：第 ${h.rouseN} 層，攻擊 +${h.rouseN * r.v('atk')}`, 'info');
      }
    }),
  ],
});
